import React, {memo, Suspense} from "react"
import {DrawerProps as MuiDrawerProps} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import {SEARCH_DATA_GA, CLOSE_SEARCH_DATA_GA} from "../../config/constants"
import {useMediaQuery} from "../../hooks/useMediaQuery"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import {IconContainer} from "./component"
import connect from "./connect"

// Todo: User Story: 390254 - Consumption of this component needs migrating to @next/drawer
// https://dev.azure.com/Next-Technology/Ecom.Backlog/_workitems/edit/390254

export type DrawerProps = Pick<MuiDrawerProps, "open" | "anchor" | "children"> & {
    onClose: () => void
    text: any
    showCloseIcon: boolean
    realm: string
    variant: string
    iconsVersionPath: string
}

export type DrawerPropsWithTemplating = DrawerProps & {
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

const Drawer = memo(
    ({
        anchor,
        open,
        onClose,
        children,
        text,
        showCloseIcon,
        realm,
        variant,
        iconsVersionPath,
        templating,
    }: DrawerPropsWithTemplating) => {
        const shouldDisableScrollLock = useMediaQuery(`(min-width:${breakpoints.values.md}px)`)

        const modalProps = {
            keepMounted: false,
            disableRestoreFocus: true,
            disableAutoFocus: true,
            disableEnforceFocus: true,
            closeAfterTransition: false,
            disablePortal: true,
            disableScrollLock: shouldDisableScrollLock,
            hideBackdrop: false,
        }
        const TemplatedDrawerContainer = useTemplatedComponent(templating, MANIFEST)
        return (
            <Suspense>
                <TemplatedDrawerContainer
                    className="drawer"
                    anchor={anchor}
                    open={open}
                    onClose={onClose}
                    ModalProps={modalProps}
                    data-testid="drawer-container"
                >
                    {showCloseIcon && (
                        <IconContainer anchor={anchor} data-testid="drawer-close-icon">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={onClose}
                                data-ga-v1={SEARCH_DATA_GA}
                                data-ga-v2={CLOSE_SEARCH_DATA_GA}
                            >
                                <use
                                    className="default"
                                    href={`${formatCdnPathWithVariant(
                                        "cross-m-default.svg",
                                        realm,
                                        variant,
                                        iconsVersionPath,
                                    )}#default`}
                                />
                            </svg>
                        </IconContainer>
                    )}
                    {children}
                </TemplatedDrawerContainer>
            </Suspense>
        )
    },
)
Drawer.displayName = "Drawer"
export default connect(Drawer)
